import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorMaterialForSceneManagerQueryVariables = Types.Exact<{
  articleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  organizationLegacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorMaterialForSceneManagerQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, legacyId: number, articleId?: string | null, latestCyclesRevision?: { __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number } | null } | null };

export type DataObjectAssignmentDetailsForTemplateImageViewerFragment = { __typename: 'DataObjectAssignment', id: string };

export type CreateDataObjectAssignmentForSceneManagerServiceMutationVariables = Types.Exact<{
  input: Types.MutationCreateDataObjectAssignmentInput;
}>;


export type CreateDataObjectAssignmentForSceneManagerServiceMutation = { __typename: 'Mutation', createDataObjectAssignment: { __typename: 'DataObjectAssignment', id: string } };

export const DataObjectAssignmentDetailsForTemplateImageViewerFragmentDoc = gql`
    fragment DataObjectAssignmentDetailsForTemplateImageViewer on DataObjectAssignment {
  id
}
    `;
export const ConfiguratorMaterialForSceneManagerDocument = gql`
    query configuratorMaterialForSceneManager($articleId: String, $organizationLegacyId: Int) {
  configuratorMaterial(
    articleId: $articleId
    organizationLegacyId: $organizationLegacyId
  ) {
    id
    legacyId
    articleId
    latestCyclesRevision {
      id
      legacyId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorMaterialForSceneManagerGQL extends Apollo.Query<ConfiguratorMaterialForSceneManagerQuery, ConfiguratorMaterialForSceneManagerQueryVariables> {
    override document = ConfiguratorMaterialForSceneManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDataObjectAssignmentForSceneManagerServiceDocument = gql`
    mutation createDataObjectAssignmentForSceneManagerService($input: MutationCreateDataObjectAssignmentInput!) {
  createDataObjectAssignment(input: $input) {
    ...DataObjectAssignmentDetailsForTemplateImageViewer
  }
}
    ${DataObjectAssignmentDetailsForTemplateImageViewerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDataObjectAssignmentForSceneManagerServiceGQL extends Apollo.Mutation<CreateDataObjectAssignmentForSceneManagerServiceMutation, CreateDataObjectAssignmentForSceneManagerServiceMutationVariables> {
    override document = CreateDataObjectAssignmentForSceneManagerServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }